import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Loader, EmptyState } from "@/components/shared";
import * as Icons from "lucide-react";

export default function Points() {
  const { data, isLoading } = useQuery({ queryKey: ["ledger"], queryFn: async () => (await api.get("/points/ledger")).data });
  if (isLoading) return <Loader />;

  return (
    <div className="space-y-6" data-testid="points-page">
      <div className="rounded-3xl gradient-orange p-6 text-white text-center">
        <p className="font-bold uppercase text-white/80">Your Story Points</p>
        <div className="font-head text-6xl">⭐ {data.total}</div>
        <p className="mt-1 text-white/80">Total earned: {data.total_earned} XP</p>
      </div>

      <h3 className="font-head text-2xl text-csh-blue">Point Ledger</h3>
      {(!data.transactions || data.transactions.length === 0) ? <EmptyState icon="Star" title="No points yet" text="Attend classes and complete quests to earn Story Points!" /> : (
        <div className="space-y-2">
          {data.transactions.map((t) => (
            <div key={t.id} className="flex items-center justify-between rounded-2xl bg-white px-4 py-3 shadow-sm border border-black/5" data-testid="ledger-row">
              <div className="flex items-center gap-3">
                <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${t.amount >= 0 ? "bg-green-100" : "bg-red-100"}`}>
                  <Icons.Star size={18} className={t.amount >= 0 ? "text-green-600" : "text-red-500"} />
                </div>
                <div>
                  <div className="font-bold text-csh-blue">{t.reason}</div>
                  <div className="text-xs text-muted-foreground">{t.created_at?.slice(0, 10)}</div>
                </div>
              </div>
              <div className={`font-head text-xl ${t.amount >= 0 ? "text-green-600" : "text-red-500"}`}>{t.amount >= 0 ? "+" : ""}{t.amount}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
